import { useAtomValue } from 'jotai'
import React from 'react'
import { match } from 'ts-pattern'

import { isPercentageAtom, tableChartTypeAtom } from '../../atoms'
import { useCategories } from '../../hooks/useCategories'
import { type SeriesItem } from '../../utils'

import { TimeSeriesChart } from './TimeSeriesChart'
import { TimeSeriesTable } from './TimeSeriesTable'

export type TimeSeriesContentProps = {
  isPercentageOnly?: boolean
  series: SeriesItem[]
}

export const TimeSeriesContent = ({
  isPercentageOnly = false,
  series,
}: TimeSeriesContentProps) => {
  const tableChartType = useAtomValue(tableChartTypeAtom)
  const categories = useCategories()
  const isPercentage = useAtomValue(isPercentageAtom) || isPercentageOnly

  return match(tableChartType)
    .with('chart', () => (
      <TimeSeriesChart
        categories={categories}
        chartType="line"
        isFixedWidth={true}
        isPercentage={isPercentage}
        series={series}
      />
    ))
    .with('table', () => (
      <TimeSeriesTable
        categories={categories}
        isPercentage={isPercentage}
        series={series}
      />
    ))
    .exhaustive()
}
